/**
 * สระอำสองแบบที่ตาเห็นเหมือนกัน: "ำ" (U+0E33) กับ นิคหิต + สระอา "ํา" (U+0E4D U+0E32)
 *
 * feedback Suraluck 18 ก.ย. 2026: ชื่อโครงการ "…จํากัด" (คัดลอกจาก PDF = แบบแยก) พิมพ์ "จำกัด" แล้วค้นไม่เจอ
 * กติกาเดียวกับ backend `app/utils/thai_text.compose_sara_am` — ฝั่งจอใช้กับการกรองที่ทำในหน้าเว็บเอง
 * (dropdown ที่ไม่ได้ค้นที่ server) · รองรับวรรณยุกต์คั่นกลาง "นํ้า" / "น้ํา" → "น้ำ"
 */
const DECOMPOSED_SARA_AM = /ํ([่-๋]?)า/g;

export const composeSaraAm = (text: string): string =>
  text.includes('ํ') ? text.replace(DECOMPOSED_SARA_AM, '$1ำ') : text;

/** คีย์สำหรับเทียบข้อความตอนค้นหา: สระอำแบบเดียว + ไม่สนตัวพิมพ์ */
export const searchKey = (text: string): string => composeSaraAm(text).toLowerCase();
